import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

import EventEditActionButtons from '@/pages/CreateEventProcessingPage/ui/layout/EventEditActionButtons.vue'
import { IEventEdit } from '@/enitites/event'
import { useSetPaymentSystem } from '@/modules/Payment/api/queries'
import { TSetPaymentSystemPayload } from '@/modules/Payment/types'
import { ModalWrapper } from '@/shared/ui/modals'
import IconTier from '@/features/tickets/assets/IconTier.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventPaymentMode',
  props: {
    eventData: null
  },
  emits: ["next", "back", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'next'): void
  (e: 'back'): void
  (e: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  eventData: IEventEdit
};

const { mutate: setPaymentSystem, isPending, error } = useSetPaymentSystem()





const isPaymentSystemEnabled = ref<boolean>(!!props.eventData.paymentSystem?.isEnabled)
const isShowLearnMore = ref(false)

function saveEventData(onSuccess: () => void) {
  if (isPending.value) return

  const payload: TSetPaymentSystemPayload = isPaymentSystemEnabled.value
    ? {
        isEnabled: true,
        isRefundable: props.eventData.paymentSystem?.isRefundable || false,
        refundableUntil: props.eventData.paymentSystem?.refundableUntil || '',
        selectedBankId: props.eventData.paymentSystem?.selectedBankId,
      }
    : {
        isEnabled: false,
        priceRange: props.eventData.paymentSystem?.priceRange || '',
        purchaseTicketsExternalUrl: props.eventData.paymentSystem?.purchaseTicketsExternalUrl || '',
      }

  setPaymentSystem(
    {
      eventId: props.eventData.id,
      payload,
    },
    { onSuccess }
  )
}

function handleNext() {
  saveEventData(() => {
    emit('next')
  })
}

function handleCancel() {
  saveEventData(() => {
    emit('cancel')
  })
}

return { __sfc: true,setPaymentSystem, isPending, error, props, emit, isPaymentSystemEnabled, isShowLearnMore, saveEventData, handleNext, handleCancel, EventEditActionButtons, ModalWrapper, IconTier }
}

})